<p>help-common-pipeline-name works!</p>
